import { Modal } from "react-bootstrap";
import PropTypes from "prop-types";

import AddGuestForm from "../AddGuestForm";
import { useAuth } from "../../services/wp.auth.service";
import { useCallback } from "react";
import { useCourseRegistration } from "../../services/CourseRegistrationProvider";

export const AttendeeAddGuestModal = ({
	onCancel,
	show
}) => {
	const { user } = useAuth();
	const {
		addGuest
	} = useCourseRegistration();

	const handleRegister = useCallback((values) => {
		addGuest(
			show,
			{
				...values,
				isMinor: values.isMinor === "Yes",
				guestOf: String(user.databaseId)
			}
		);
		onCancel();
	}, [show, addGuest]);
	return (
		<Modal centered onHide={onCancel} show={Boolean(show)}>
			<AddGuestForm handleHide={onCancel} registerGuest={handleRegister} />
		</Modal>
	);
};

AttendeeAddGuestModal.propTypes = {
	onCancel: PropTypes.func.isRequired,
	show: PropTypes.number
};

AttendeeAddGuestModal.defaultProps = {
	show: null
};

export default AttendeeAddGuestModal;
